import React from "react";
import { Container, NavLink } from "theme-ui";
import { Link as GatsbyLink } from "gatsby";

const ArticleBack = () => (
  <Container variant="blog">
    <NavLink as={GatsbyLink} to="../">
      ‹ Tutti gli articoli
    </NavLink>
  </Container>
);

export default ArticleBack;
